import React from 'react';
import Main from './pages/Main';
import '../src/App.css'
function App() {
  return (
      <div>
        <Main/>
      </div>
  );
}

export default App;
